import { MDBCard, MDBCardBody, MDBIcon} from 'mdb-react-ui-kit'
import React, { useState, useEffect, useRef } from 'react'
import backdrop from "../assets/images/backdrop.png";
import { useNavigate } from 'react-router-dom';

export function PlanCardSlider({ planData, membership }) {
    console.log("PlanCardSlider", planData, membership)
    // Initialize hooks at the top level
    const [currentSlide, setCurrentSlide] = useState(0);
    const sliderRef = useRef(null);
    const intervalRef = useRef(null);
    const navigate = useNavigate();


    const updatePricing = (planid) => {
        const plandetails = membership.length > 0 ? membership.find((item) => item._id === planid) : {}
        console.log(plandetails, 'plandetails')

        return (plandetails?.price || 0).toLocaleString('en-IN')

    }

    // Auto-scroll functionality
    useEffect(() => {
        if (!planData || !planData.items) return;

        const startAutoScroll = () => {
            intervalRef.current = setInterval(() => {
                setCurrentSlide(prev => (prev + 1) % planData.items.length);
            }, 3000); // Change slide every 3 seconds
        };

        if (planData.items && planData.items.length > 0) {
            startAutoScroll();
        }
        return () => clearInterval(intervalRef.current);
    }, [planData?.items?.length]);

    // Handle manual slide change
    const goToSlide = (index) => {
        if (!planData || !planData.items) return;
        setCurrentSlide(index);
        clearInterval(intervalRef.current);
        intervalRef.current = setInterval(() => {
            setCurrentSlide(prev => (prev + 1) % planData.items.length);
        }, 3000);
    };

    const nextSlide = () => {
        if (!planData || !planData.items) return;
        goToSlide((currentSlide + 1) % planData.items.length);
    };

    const prevSlide = () => {
        if (!planData || !planData.items) return;
        goToSlide((currentSlide - 1 + planData.items.length) % planData.items.length);
    };

    // If no planData is passed, return null at the end
    if (!planData || !planData.items) return null;

    const handleselectplan = (plan) => {
        const filteredItem = membership.length > 0 ? membership.find((item) => item._id === plan) : {}
        console.log(filteredItem);

        navigate('/memberbilling', { state: { cartItems: [filteredItem] } })
    }

    return (
        <>
            <div className='palnsection position-relative' style={{ backgroundColor: planData.backgroundcolor }}>
                <div className='container'>
                    <div className='sectionheader text-center mb-5'>
                        <div className="plansubtile" dangerouslySetInnerHTML={{ __html: planData.subtitle || "<p>Get plans</p>" }} />
                        <div dangerouslySetInnerHTML={{ __html: planData.title || "<h4>Membership plans</h4>" }} />
                    </div>

                    <div className="position-relative">
                        {/* Navigation arrows */}
                        {planData.items.length > 3 && (
                            <>
                                <button
                                    onClick={prevSlide}
                                    className="slider-arrow slider-arrow-left"
                                >
                                    <MDBIcon fas icon="chevron-left" />
                                </button>

                                <button
                                    onClick={nextSlide}
                                    className="slider-arrow slider-arrow-right"
                                >
                                    <MDBIcon fas icon="chevron-right" />
                                </button>
                            </>
                        )}

                        {/* Slider container */}
                        <div
                            ref={sliderRef}
                            className="slider-container"
                            style={{
                                display: 'flex',
                                overflow: 'hidden',
                                position: 'relative',
                                width: '100%'
                            }}
                        >
                            <div
                                className="slider-track"
                                style={{
                                    display: 'flex',
                                    transition: 'transform 0.5s ease',
                                    transform: `translateX(-${currentSlide * (100 / Math.min(3, planData.items.length))}%)`,
                                    width: `${100 * planData.items.length / Math.min(3, planData.items.length)}%`
                                }}
                            >
                                {planData.items.map((plan, index) => {
                                    const themeColor = plan.themecolor || '#007bff';
                                    const buttonHoverColor = plan.themecolor ? `${plan.themecolor}90` : '#0069d9';

                                    return (
                                        <div
                                            key={plan.id || index}
                                            className="slider-slide"
                                            style={{
                                                flex: `0 0 ${100 / Math.min(3, planData.items.length)}%`,
                                                padding: '0 15px',
                                                boxSizing: 'border-box'
                                            }}
                                        >
                                            <MDBCard
                                                className='h-100'
                                                style={{
                                                    border: `2px solid ${themeColor}`,
                                                    transition: 'all 0.3s ease'
                                                }}
                                            >
                                                {plan.ispopular && (
                                                    <div
                                                        className="popular-badge"
                                                        style={{
                                                            backgroundColor: plan.themecolor || '#007bff'
                                                        }}
                                                    >
                                                        {plan.tagtext || "POPULAR"}
                                                    </div>
                                                )}
                                                <MDBCardBody className='d-flex flex-column h-100'>
                                                    <div className='planheader'>
                                                        <div
                                                            className='plan_icon'
                                                            style={{
                                                                backgroundColor: themeColor,
                                                                color: '#ffffff'
                                                            }}
                                                        >
                                                            <MDBIcon icon={plan.icon} size="lg" />
                                                        </div>
                                                        <div className='plan_title'>
                                                            <h4 className='m-0'>{plan?.name || `Plan ${index + 1}`}</h4>
                                                            {/* {plan?.name ?? plan?.displayName ?? `Plan ${index + 1}`} */}

                                                        </div>
                                                    </div>

                                                    <div className='planbody mt-3 h-100'>
                                                        <ul className='planulist p-0'>
                                                            {plan.features.map((feature, i) => (
                                                                <li key={i} className='planList'>
                                                                    <span className='check-list' style={{ background: themeColor }}>
                                                                        <i className="fas fa-check"></i>
                                                                    </span>
                                                                    {feature}
                                                                </li>
                                                            ))}
                                                        </ul>
                                                    </div>

                                                    <div className='plan_footer mt-2'>
                                                        <div className='plan_price'>
                                                            <div className='d-flex justify-content-center'>
                                                                <span className='fs-6 me-1 text-secondary'>₹</span>
                                                                <div className='pricePlan'>
                                                                    <h3 className='m-0'>{plan.planid ?
                                                                        updatePricing(plan?.planid)
                                                                        : "0"}</h3>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <button
                                                            className={`btnn hover-filled-slide-down w-100 mt-4`}
                                                            style={{
                                                                backgroundColor: themeColor,
                                                            }}
                                                            onClick={() =>
                                                                handleselectplan(plan?.planid)
                                                            }
                                                        >
                                                            <span>{plan?.btntext ? plan.btntext : "Choose Plan"}</span>
                                                        </button>
                                                    </div>
                                                </MDBCardBody>
                                            </MDBCard>
                                        </div>
                                    );
                                })}
                            </div>
                        </div>
                    </div>

                    {/* Slide indicators */}
                    <div className="slider-indicators" style={{
                        display: 'flex',
                        justifyContent: 'center',
                        marginTop: '20px'
                    }}>
                        {planData.items.map((_, index) => (
                            <button
                                key={index}
                                onClick={() => goToSlide(index)}
                                style={{
                                    width: '12px',
                                    height: '12px',
                                    borderRadius: '50%',
                                    border: 'none',
                                    margin: '0 5px',
                                    backgroundColor: currentSlide === index ? '#7b5cfa' : '#ccc',
                                    cursor: 'pointer'
                                }}
                            />
                        ))}
                    </div>
                </div>

                {/* Backdrop elements */}
                <div className='backdrop elemt1'>
                    <img src={backdrop} alt="" />
                </div>
                <div className='backdrop elemt2'>
                    <img src={backdrop} alt="" />
                </div>
            </div>
        </>
    )
}

export default PlanCardSlider;